import { render, staticRenderFns } from "./Popularize.vue?vue&type=template&id=2cf65741&scoped=true"
import script from "./Popularize.vue?vue&type=script&lang=js"
export * from "./Popularize.vue?vue&type=script&lang=js"
import style0 from "./Popularize.vue?vue&type=style&index=0&id=2cf65741&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf65741",
  null
  
)

export default component.exports